<template>
  <!-- 设备历史数据 -->
  <a-row :bordered="false">
    <a-col :md="5"
           :sm="24"
           style="margin-right: 20px">
      <a-card style="height: 715px">
        <div slot="title"
             class="cardTitle">泵房设备</div>
        <div class="box">
          <a-tree v-if="zoneTreeData.length"
                  :defaultExpandAll="true"
                  :auto-expand-parent="false"
                  :replace-fields="{ title: 'pumpName', key: 'id', value: 'pumpNo', selectable: 'selectable' }"
                  :tree-data="zoneTreeData"
                  @expand="onExpand"
                  @select="onSelect" />
        </div>
      </a-card>

      <!-- </a-form-item> -->
    </a-col>
    <a-col :md="18"
           :sm="24">
      <a-card>
        <a-form layout="inline">
          <a-row :gutter="24">
            <a-col style="margin-bottom: 12px">
              <a-form-item label="设备编号">
                <a-input v-model="query.deviceNo"
                         placeholder="请输入设备编号"
                         allow-clear />
              </a-form-item>
              <a-form-item label="位置">
                <a-input v-model="query.address"
                         placeholder="请输入位置"
                         allow-clear />
              </a-form-item>

              <a-form-item label="采集时间">
                <a-range-picker :show-time="{ format: 'YYYY-MM-DD' }"
                                format="YYYY-MM-DD"
                                :placeholder="['推送开始时间', '推送结束时间']"
                                @change="pushOnChange"
                                v-model="pushTime" />
              </a-form-item>
              <a-form-item style="margin-left: 12px">
                <a-button type="primary"
                          @click="queryList">查询</a-button>
                <a-button @click="resetList"
                          style="margin-left: 12px">重置</a-button>
                <a-button type="danger"
                          style="margin-left: 12px"
                          @click="deleteSelectRow()">删除</a-button>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
        <a-row>
          <!-- 表格 -->
          <a-table size="middle"
                   rowKey="id"
                   bordered
                   :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
                   :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
                   :data-source="list"
                   :columns="columns"
                   :scroll="{ x: 1800 }"
                   :loading="dataListLoading"
                   :pagination="pagination"
                   @change="pageChange">
            <template slot="statusFlow"
                      slot-scope="text">
              <a-tag v-if="text == '有效'"
                     color="green"> 有效 </a-tag>
              <a-tag v-if="text == '不确定'"
                     color="blue"> 不确定 </a-tag>
              <a-tag v-if="text == '无效'"
                     color="red"> 无效 </a-tag>
            </template>
            <template slot="typeAction"
                      slot-scope="text">
              <span v-if="text == 0">原水</span>
              <span v-if="text == 1">出厂水</span>
              <span v-if="text == 2">管末端梢水</span>
              <span v-if="text == 3">总出厂水流量</span>
              <span v-if="text == 4">清水池</span>
              <span v-if="text == 5">次氯酸钠</span>
              <span v-if="text == 6">加矾</span>
              <span v-if="text == 10">二供</span>
            </template>
          </a-table>
        </a-row>
        <!-- 新增 修改 的弹框 -->
        <a-modal title="新增"
                 style="top: 20px"
                 :width="800"
                 :visible="addOrUpdateVisible"
                 v-model="addOrUpdateVisible"
                 @ok="handleOk"
                 @cancel="handleCancel"></a-modal>
      </a-card>
    </a-col>
  </a-row>
</template>

<script>
import mixinViewModule from '@/mixin/common'
const columns = [
  {
    title: '类型',
    dataIndex: 'type',
    scopedSlots: { customRender: 'typeAction' },
    align: 'center',
    fixed: 'left',
    width: 100
  },
  {
    title: '位置',
    dataIndex: 'address',
    width: 200,
    ellipsis: true
  },
  {
    title: '设备名称',
    dataIndex: 'deviceName',
    width: 200,
    ellipsis: true
  },
  {
    title: '设备编码',
    dataIndex: 'deviceNo',
    width: 100,
    ellipsis: true
  },
  {
    title: '液位',
    dataIndex: 'level',
    width: 100,
    ellipsis: true
  },
  {
    title: '电压',
    dataIndex: 'voltage',
    width: 100,
    ellipsis: true
  },
  {
    title: '电流',
    dataIndex: 'current',
    width: 100,
    ellipsis: true
  },
  {
    title: '功耗',
    dataIndex: 'consumption',
    width: 100,
    ellipsis: true
  },
  {
    title: '压力',
    dataIndex: 'pressure',
    width: 100,
    ellipsis: true
  },
  {
    title: '变频器频率',
    dataIndex: 'frequency',
    width: 100,
    ellipsis: true
  },
  {
    title: '流量',
    dataIndex: 'flow',
    width: 100,
    ellipsis: true
  },
  {
    title: '余氯mg/L',
    dataIndex: 'chlorine',
    width: 100,
    ellipsis: true
  },
  {
    title: '浊度NTU',
    dataIndex: 'turbidity',
    width: 100,
    ellipsis: true
  },
  {
    title: 'ph',
    dataIndex: 'ph',
    width: 100,
    ellipsis: true
  },
  {
    title: '溶解氧',
    dataIndex: 'dissolvedOxygen',
    width: 100,
    ellipsis: true
  },
  {
    title: '水淹（水位高度cm）',
    dataIndex: 'waterLevel',
    width: 200,
    ellipsis: true
  },
  {
    title: '温度',
    dataIndex: 'temperature',
    width: 100,
    ellipsis: true
  },
  {
    title: '湿度',
    dataIndex: 'humidity',
    width: 100,
    ellipsis: true
  },
  {
    title: '采集时间',
    dataIndex: 'collectTime',
    width: 200,
    ellipsis: true
  },
  {
    title: '创建时间',
    dataIndex: 'createTime',
    width: 200,
    ellipsis: true
  }
]

export default {
  components: {},
  mixins: [mixinViewModule],
  name: 'Task',
  data () {
    return {
      queryUrl: '/pipe-network/water_quality_historys/page/device', // 列表请求数据接口
      addOrUpdateUrl: '', // 新增
      queryOneUrl: '', // 查询单条地址
      deleteUrl: '/pipe-network/water_quality_historys', // 删除
      staffTreeData: [], // 分区数据选项
      bookTreeData: [], // 分区数据选项
      zoneTreeData: [], // 泵房选项
      selectedKeys: [],
      pushTime: [],
      query: {
        taskName: '',
        deviceNo: '',
        address: '',  
        queryBeginTime: '',
        queryEndTime: '',
        qualityId: '',
        type: 10
      }, // 查询参数
      addOrUpdateVisible: false, // 新增修改是否可见
      addOrUpdateForm: this.$form.createForm(this, { name: 'addOrUpdate' }), // 新增 修改
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      columns
    }
  },
  created () {
    this.i()
  },
  methods: {
    i () {
      this.$http.get('/pipe-network/twice_water_pumps/tree').then((res) => {
        this.zoneTreeData = res.data
      })
    },
    // 重置
    resetList () {
      this.pushTime = []
      this.pagination.current = 1
      this.collectionTime = []
      this.selectedRows = []
      this.query = {
        taskName: '',
        deviceNo: '',
        address: '',
        queryBeginTime: '',
        queryEndTime: '',
        qualityId: '',
        type: 10
      }
      this.queryList()
    },
    pushOnChange (value, dateString) {
      this.query.queryBeginTime = dateString[0]
      this.query.queryEndTime = dateString[1]
    },
    onExpand (expandedKeys) {
      this.expandedKeys = expandedKeys
      this.autoExpandParent = false
    },
    onSelect (selectedKeys, info) {
      console.log('onSelect', selectedKeys[0])
      this.query.qualityId = selectedKeys[0]
      this.queryList()
    }
  }
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}
.cardTitle {
  font-family: MicrosoftYaHeiSemibold;
  font-size: 18px;
  color: #333333;
  letter-spacing: 0.71px;
  font-weight: 600;
}
/deep/.ant-table-thead > tr > th > {
  text-align: center;
}

/deep/.ant-table-tbody > tr > td {
  text-align: center;
}
.box {
  height: 709px;
  width: 100%;
  overflow: auto;
  // 滚动条整体部分
  &::-webkit-scrollbar {
    width: 0px; //对垂直方向滚动条
    height: 0px; //对水平方向滚动条
  }
  //滚动的滑块
  &::-webkit-scrollbar-thumb {
    border-radius: 3px;
    background-color: #ccc//滚动条的颜色;
  }
  //内层滚动槽
  &::-webkit-scrollbar-track-piece {
    background-color: #ccc;
  }
}
</style>
